export const totalsNoTotalMessageSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '5px',
  padding: '8px',
  textAlign: 'center',
  margin: '8px 0',
});
